import HeaderTitle from "src/Candidate/atoms/HeaderTitle";
import HeaderDescription from "src/Candidate/atoms/HeaderDescription";
import { HeaderTextProps } from "./HeaderText.types";
import styles from "./HeaderText.module.css";

export default function HeaderText({
  title,
  description,
}: HeaderTextProps): JSX.Element {
  return (
    <div className={styles.container}>
      <HeaderTitle title={title} />
      <HeaderDescription description={description} />
    </div>
  );
}
